
export default function LuxuryChalets() {
  return (
    <section id="chalets" className="w-full py-16 md:py-24 lg:py-32 px-6 md:px-12 lg:px-24 bg-white">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-6 mb-12 md:mb-20">
          <h2
            className="text-4xl md:text-5xl lg:text-7xl font-thin tracking-wider text-gray-900"
            style={{ letterSpacing: '2px' }}
          >
            ALPINE EXCELLENCE
          </h2>
          <p className="text-base md:text-lg font-light text-gray-600 md:max-w-xs leading-relaxed">
            Our exclusive luxury chalet offers comfort and breathtaking alpine vistas in the heart of Châtel.
          </p>
        </div>

        {/* Single Chalet Feature */}
        <div className="group rounded-2xl overflow-hidden shadow-xl hover:shadow-2xl transition-all duration-500 cursor-pointer flex flex-col lg:flex-row" style={{ backgroundColor: '#F0EDE8' }}>
          {/* Image */}
          <div className="w-full lg:w-3/5 h-72 sm:h-96 lg:h-auto min-h-[320px] overflow-hidden relative">
            <img
              src="https://www.dropbox.com/scl/fi/1vn6vi4m5mag1tfrnou8p/Photo-29-01-2026-07-33-04.jpg?rlkey=jct21h1qni31ve6uphc4fahoj&st=k6ajf0x2&raw=1"
              alt="Chalet Lac de Vonnes"
              className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-700"
            />
            <div className="absolute top-4 left-4 flex flex-col gap-2">
              <div
                className="flex items-center gap-2 px-3 py-1.5 rounded-full text-xs font-semibold tracking-widest uppercase shadow-lg"
                style={{ backgroundColor: '#D4AF37', color: '#1A2332' }}
              >
                <i className="ri-sun-fill text-sm"></i>
                Summer Season Only
              </div>
              <div
                className="flex items-center gap-2 px-3 py-1.5 rounded-full text-xs font-medium tracking-wide shadow-lg"
                style={{ backgroundColor: 'rgba(26,35,50,0.85)', color: '#ffffff' }}
              >
                <i className="ri-calendar-line text-sm"></i>
                Available: June – September
              </div>
            </div>
          </div>

          {/* Details */}
          <div className="w-full lg:w-2/5 p-6 md:p-10 lg:p-12 flex flex-col justify-center">
            <div
              className="flex items-start gap-3 p-4 rounded-xl mb-6 border"
              style={{ backgroundColor: '#FFF8E7', borderColor: '#D4AF37' }}
            >
              <div className="w-7 h-7 flex items-center justify-center flex-shrink-0 mt-0.5">
                <i className="ri-information-line text-lg" style={{ color: '#D4AF37' }}></i>
              </div>
              <div>
                <p className="text-sm font-semibold text-gray-800 mb-1">Summer Availability Notice</p>
                <p className="text-xs font-light text-gray-600 leading-relaxed">
                  Chalet Lac de Vonnes is exclusively available during the summer season (June – September). Winter bookings are not accepted. Limited dates remaining for 2025.
                </p>
              </div>
            </div>

            <h3
              className="text-3xl md:text-4xl font-medium mb-4 text-gray-900"
              style={{ fontFamily: 'Cormorant Garamond, serif' }}
            >
              Chalet Lac de Vonnes
            </h3>

            <p className="text-base font-light text-gray-600 mb-6 leading-relaxed">
              Nestled in the stunning alpine landscape of Châtel, Chalet Lac de Vonnes is our signature summer retreat. Wake up to panoramic mountain views, breathe the crisp alpine air, and enjoy the finest in mountain living — available exclusively during the summer season.
            </p>

            {/* What's Included */}
            <div className="mb-8">
              <h4 className="text-xs font-semibold tracking-widest uppercase text-gray-400 mb-4">What's Included</h4>
              <div className="grid grid-cols-2 gap-3">
                {[
                  { icon: 'ri-temp-hot-line', label: 'Private Hot Tub' },
                  { icon: 'ri-bike-line', label: 'Bike Storage' },
                  { icon: 'ri-wifi-line', label: 'High-Speed Wi-Fi' },
                  { icon: 'ri-car-line', label: 'Private Parking' },
                  { icon: 'ri-landscape-line', label: 'Lake View Terrace' },
                  { icon: 'ri-fire-line', label: 'Wood Fireplace' },
                ].map((item) => (
                  <div key={item.label} className="flex items-center gap-2.5">
                    <div className="w-7 h-7 flex items-center justify-center rounded-full flex-shrink-0" style={{ backgroundColor: '#FFF8E7' }}>
                      <i className={`${item.icon} text-sm`} style={{ color: '#D4AF37' }}></i>
                    </div>
                    <span className="text-sm font-light text-gray-600 whitespace-nowrap">{item.label}</span>
                  </div>
                ))}
              </div>
            </div>

            <a
              href="#contact"
              className="inline-flex items-center gap-3 px-8 py-4 rounded-full text-sm font-medium tracking-widest uppercase transition-all duration-300 hover:opacity-90 self-start whitespace-nowrap"
              style={{ backgroundColor: '#1A2332', color: '#D4AF37' }}
            >
              Enquire Now
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line"></i>
              </div>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
